/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Photos = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Photos"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="m9.35 4.661 9.727 2.494c.895.23 1.426 1.11 1.186 1.967l-1.479 5.282v3.168a3.2 3.2 0 0 0 1.363-1.83l1.738-6.204c.48-1.714-.583-3.475-2.374-3.934L9.784 3.11c-1.791-.459-3.632.558-4.112 2.271l-.785 2.803q.23-.03.47-.031h1.277l.66-2.356c.24-.857 1.16-1.365 2.055-1.136"
      />
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M15.427 9.759H5.357c-.927 0-1.679.719-1.679 1.606v6.423c0 .887.752 1.606 1.679 1.606h10.07c.927 0 1.679-.719 1.679-1.606v-6.423c0-.887-.752-1.606-1.679-1.606M5.357 8.153C3.503 8.153 2 9.591 2 11.365v6.423C2 19.562 3.503 21 5.357 21h10.07c1.854 0 3.357-1.438 3.357-3.212v-6.423c0-1.774-1.503-3.212-3.357-3.212z"
        clipRule="evenodd"
      />
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="m10.392 12.979-2.976 3.203h5.952zm-4.23 2.137 2.976-3.204a1.73 1.73 0 0 1 2.509 0l2.976 3.204c.962 1.035.194 2.672-1.255 2.672H7.416c-1.448 0-2.217-1.637-1.254-2.672"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const PhotosIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'photos-icon'}
      icon={Photos}
      {...props}
      size={size}
    />
  );
};
